// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VRpW","box":"Footer_box__1n3Tk","switch":"Footer_switch__1idbm","coffee":"Footer_coffee__2hXNm"};